<template>
    <!-- 兑换活动管理-兑换概要组件 -->
    <a-card :title="title" class="mt24" :bordered="bordered">
        <a-row class="mb16">
            <a-col :span="8">礼券ID：{{dataDetail.couponId}}</a-col>
            <a-col :span="8">生成兑换数量：{{dataDetail.generateNum && dataDetail.generateNum.toLocaleString()}}</a-col>
            <a-col :span="8">兑换有效期：{{dataDetail.isHasExpiryDate ? (dataDetail.startExpiryDate + ' ~ ' +  dataDetail.endExpiryDate) : '不限期'}}</a-col>
        </a-row>
        <a-row class="mb16">
            <a-col :span="8">是否企业团购：{{['否','是'][dataDetail.isGroupBuy]}}</a-col>
            <a-col :span="8">兑换状态：{{dataDetail.status == '-1' ? '停用' : '正常'}}</a-col>
            <a-col :span="8">是否享受买赠：{{['否','是'][dataDetail.isHasBuyGet]}}</a-col>
        </a-row>
        <a-row v-if="dataDetail.isGroupBuy == 1">
            <a-col :span="24">团购销售门店：{{['全部门店', dataDetail.groupBuyShops][dataDetail.groupBuyShopType]}}</a-col>
        </a-row>
    </a-card>
</template>

<script type="text/javascript">
    export default {
        name: "exchangeOutline",
        components: {},
        props: {
            dataDetail: {
                default: {},
                default: () => {return {}}
            },
            bordered: {
                type: Boolean,
                default: true,
            },
            title: {
                type: String,
                default: "",
            }
        },
        data() {
            return {};
        },
        methods: {},
        beforeCreate() {},
        created() {},
        mounted() {}
    };
</script>
<style lang="scss">
</style>